<template>
  <div class="chat-action-container">
    <app-file-upload
      ref="fileUpload"
      accept="image/*"
      :acceptExts="['jpg', 'jpeg', 'png']"
      :thumbQuality="0.8"
      @submit="sendImages"/>

    <textarea
      v-model="message"
      ref="textarea"
      class="textarea"
      @keyup="onTextareaKeyup"
      @keydown="onTextareaKeydown">
    </textarea>
    <div style="display: flex;">
      <v-btn icon flat small @click="toggleFileUpload">
        <v-icon>insert_photo</v-icon>
      </v-btn>
      <!-- <v-btn icon flat small>
        <v-icon>photo_camera</v-icon>
      </v-btn> -->
      <emoji-button ref="emojiBtn" @input="onEmojiInput"/>
      <record-button @stop="sendAudioMessage" />

      <v-btn
        class="ml-auto"
        @click="sendText"
        :class="themeColor"
        :loading="loading"
        color="black"
        small
        flat>
        送出
      </v-btn>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import RecordButton from './ChatRecordButton';
import EmojiButton from './ChatEmojiButton';

export default {
  components: {
    'record-button': RecordButton,
    'emoji-button': EmojiButton
  },

  data() {
    return {
      loading: false,
      message: ''
    };
  },

  mounted() {
  },

  methods: {
    ...mapActions('chat', {
      sendTextMessage: 'sendTextMessage',
      sendAudioMessage: 'sendAudioMessage',
      sendImageMessage: 'sendImageMessage',
      recordAudio: 'recordAudio'
    }),

    onTextareaKeyup(e) {
      if (e.keyCode === 16) {
        this._isShiftDown = false;
      }
    },

    onTextareaKeydown(e) {
      if (e.keyCode === 16) {
        this._isShiftDown = true;
        return;
      }
      if (this._isShiftDown && e.keyCode === 13) {
        this.resizeTextarea();
        return;
      }
      if (e.keyCode === 13) {
        e.preventDefault();
        this.sendText();
        this.resizeTextarea();
      }
    },

    onEmojiInput(char) {
      this.message += char;
    },

    resizeTextarea() {
      let el = this.$refs.textarea;
      setTimeout(() => {
        el.style.cssText = 'height:auto; padding:0';
        // for box-sizing other than "content-box" use:
        // el.style.cssText = '-moz-box-sizing:content-box';
        el.style.cssText = 'height:' + el.scrollHeight + 'px';
      }, 0);
    },

    async sendImages(files) {
      await this.sendImageMessage(files);
    },

    toggleFileUpload() {
      this.$refs.fileUpload.toggle();
    },

    sendText() {
      if (!this.message || this.message === '') {
        return;
      }
      this.sendTextMessage(this.message);
      this.message = '';
    },

    breakLine() {
      this.message = this.message + '\n';
    }
  }
};
</script>

<style lang="stylus" scoped>

.chat-action-container {
  position: relative;
  border-top: 1px solid darken($secondary-color, 10%);
}

.textarea {
  width: 100%;
  overflow: auto;
  min-height: 10vh;
  max-height: 40vh;
  padding: 1rem;
  outline: none;
  transition: 0.2s;
  font-size: 1.2rem;
  &:hover {
    // background-color: lighten($secondary-color, 80%);
    background-color: rgba(0,0,0,0.05);
  }
}
</style>